export const ACTION = {
    GET_FETCH_CMS_DETAILS: 'GET_FETCH_CMS_DETAILS',
}